export default __webpack_public_path__ + "static/media/DineshPunni.d8fd0ecf.jpeg";